namespace Areas.Program.Analysis {
    "use strict";

    export function onCellPrepared(e: any) {
        if (e.rowType !== "data") {
            return;
        }
        //setPifPafAmountBackground(e);
        //setCIBAmountBackground(e);
    }

    //function setPifPafAmountBackground(e) {
    //    var isPifPafDataCell = e.column.dataField === "pifpafAmount";

    //    if (isPifPafDataCell) {
    //        if (e.data.pifpafBalance < 0) {
    //            e.cellElement.css("background-color", "yellow"); 
    //        } else if (e.data.pifpafAmount < e.data.cibBudgetAmount ) {
    //            e.cellElement.css("background-color", "yellow"); 
    //        }
    //    }
    //}

    //function setCIBAmountBackground(e) {
    //    var isCIBDataCell = e.column.dataField === "cibBudgetAmount";

    //    if (isCIBDataCell) {
    //        if (e.data.cibBudgetAmount < e.data.pifpafAmount && e.data.pifpafAmount > 1000000) {
    //            e.cellElement.css("background-color", "#FFA07A"); 
    //        } else if (e.data.cibBudgetAmount < e.data.appropriation && e.data.appropriation > 1000000) {
    //            e.cellElement.css("background-color", "red"); 
    //        }
    //    }
    //}

    //function setStatusCellBackground(e) {
    //    var isStatusDataCell = e.column.dataField === "status";

    //    if (isStatusDataCell) {
    //        if (e.data.status === 'Approved') {
    //            e.cellElement.css('background-color', '#90EE90');
    //        } else if (e.data.status === 'HOLD') {
    //            e.cellElement.css('background-color', 'yellow');
    //        } else if (e.data.status === 'DELETED') {
    //            e.cellElement.css('background-color', 'red');
    //        }
    //    }
    //}


    export function projectViewLink(cellElement: any, cellInfo: any) {
        let linkInfo = "<a href= '/Account/Profile/View/{placeholder}' target=\"_blank\">View</a>";

        buildCellContent(cellElement,
            () => { return cellInfo.data.accountId; },
            linkInfo);
    }

    export function goToAccount(e: any) {
        const grid = $("#ActiveProjectsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].accountId;
            let linkInfo = "/Account/Profile/View/" + id;
            window.open(linkInfo);
        }
    }

    export function goToProject(e: any) {
        const grid = $("#ActiveProjectsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].accountId;
            let linkInfo = "/Account/Profile/View/" + id;
            window.open(linkInfo);
        }
    }

    export function goToSharePoint(e: any) {
        const grid = $("#ActiveProjectsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var sharePointLink = row[0].sharePointLink;
            let linkInfo = "https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjects/" + sharePointLink + "/";
            if (sharePointLink != "") {
                window.open(linkInfo);
            }
            else {
                window.open("https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjectsList");
            }
        }
    }

    export function goToPIFPAF(e: any) {
        const grid = $("#ActiveProjectsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].projectInfoId;
            let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + id + "";
            if (id != null) {
                window.open(linkInfo);
            }
        }
    }


}